(function () {
  'use strict';

  var SET_TTL = 30 * 24 * 3600;
  var STORAGE_KEY_SET = 'amz_s';

  function now() { return Date.now(); }

  function lsGet(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }

  function lsSet(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function log() {
    var args = ['[AMZ]'];
    for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
    console.log.apply(console, args);
  }

  function getCountryCode() {
    var p = new URLSearchParams(location.search);
    var tc = p.get('test_country');
    if (tc) return tc;
    if (window.Shopify && window.Shopify.country) return window.Shopify.country;
    return null;
  }

  function getAssetsBase() {
    var cfg = window.amzConfig || {};
    if (cfg.assetsBase) return cfg.assetsBase;
    var el = document.querySelector('script[src*="amz-core"]');
    if (el) {
      var src = el.src;
      var idx = src.indexOf('/assets/');
      if (idx !== -1) return src.substring(0, idx + 8);
    }
    return '';
  }

  function fetchSetFile(setName, assetsBase, setUrl) {
    var url = setUrl || (assetsBase + setName + '.js?t=' + now());
    log('Loading set file:', url);
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (text) {
      return text.replace(/\/\*\*[\s\S]*?\*\*\//g, '').trim();
    }).catch(function (err) {
      console.warn('[AMZ] Set file fetch failed:', err.message);
      return null;
    });
  }

  function getVisitorDigit(testRand) {
    if (testRand != null) return parseInt(testRand, 10);
    var stored = sessionStorage.getItem('amz_vd');
    if (stored !== null) return parseInt(stored, 10);
    var digit = Math.floor(Math.random() * 10);
    sessionStorage.setItem('amz_vd', String(digit));
    return digit;
  }

  function parseSetText(text, country, testRand) {
    var items = [];
    var lines = text.split('\n');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var parts = line.split(/\s+/);
      if (parts.length < 3) continue;

      var cc = parts[0];
      var handle = parts[1];
      var url = parts[2];
      var rawMode = parts[3];
      var rawRand = parts[4];

      if (cc !== country) continue;

      if (rawRand === '1') {
        var digit = getVisitorDigit(testRand);
        if (digit % 2 !== 0) continue;
      }

      items.push({
        h: handle,
        u: url,
        b: parseInt(rawMode || '1', 10)
      });
    }
    return items;
  }

  function publish(data) {
    window.amzData = data;
    window.dispatchEvent(new CustomEvent('amz:ready', { detail: data }));
  }

  function init() {
    var cfg = window.amzConfig || {};
    var allowedCountries = cfg.countries || ['US', 'GB', 'CA', 'UA'];
    var params = new URLSearchParams(location.search);
    var urlSet = params.get('set');
    var testRand = params.get('test_rand');

    var country = getCountryCode();
    log('Country:', country);

    if (!country || allowedCountries.indexOf(country) === -1) {
      log('Country "' + country + '" not in allowed list — skipping');
      publish({ set: [], country: country });
      return Promise.resolve();
    }

    if (!urlSet) {
      var cached = lsGet(STORAGE_KEY_SET);
      if (cached && cached.set && cached.country === country && (now() - cached.created) < SET_TTL * 1000) {
        log('Using cached set. Items:', cached.set.length);
        publish(cached);
        return Promise.resolve();
      }
    } else {
      log('URL set param detected:', urlSet, '— bypassing cache');
    }

    var setName = urlSet || cfg.defaultSetName || 's0_default';
    var assetsBase = getAssetsBase();

    var setUrl = (cfg.setFiles && cfg.setFiles[setName]) || (urlSet ? null : (cfg.setFileUrl || null));
    return fetchSetFile(setName, assetsBase, setUrl).then(function (rawText) {
      if (!rawText) {
        log('Empty set file — skipping');
        publish({ set: [], country: country });
        return;
      }

      var setItems = parseSetText(rawText, country, testRand);
      var result = { created: now(), country: country, set: setItems };

      lsSet(STORAGE_KEY_SET, result);

      log('Set "' + setName + '" ready —', setItems.length, 'items for country "' + country + '"');
      publish(result);
    });
  }

  window.amzReady = new Promise(function (resolve) {
    window.addEventListener('amz:ready', function (e) { resolve(e.detail); }, { once: true });
  });

  init().catch(function (err) {
    console.error('[AMZ] Core init error:', err);
    publish({ set: [], country: null });
  });
})();
